<script>
import MerchPlans from '@/pages/merch-plans/index.vue';

export default {
  ...MerchPlans,
  nuxtI18n: {
    paths: {
      en: '/merch-plans/:keyword',
      de: '/merch-abos/:keyword',
      es: '/planes-merch/:keyword',
      pt: '/planos-merch/:keyword'
    }
  },
  head() {
    const path = 'merch-plans';
    const params = {
      en: this.localePath(path, 'en'),
      es: this.localePath(path, 'es'),
      pt: this.localePath(path, 'pt'),
      de: this.localePath(path, 'de')
    };
    const hreflangs = this.$hrefLangPlugin(params, true);
    const canonicalLink = this.$trailingSlash(this.localePath(path));
    return {
      link: [
        {
          hid: 'i18n-can',
          href: canonicalLink,
          rel: 'canonical'
        },
        ...hreflangs
      ]
    };
  }
};
</script>
